import ApiConstants from "../constants/ApiConstants";
import http from "../http";

export interface ExpenseLimitAPIConfig {
  params?: Object;
  queryParams?: Object;
}

class ExpenseLimitPolicyService {
  static apiConfig: ExpenseLimitAPIConfig;

  static saveExpenseLimitPolicy(paylaod) {
    const url = `${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.POST_LIMIT_POLICY}`
    return http.post(url, paylaod).catch(
      (error) => {
        console.error('Error Posting expenses Limit: ', error);
        return Promise.reject(error);
      }
    )
  }

  static updateExpenseLimitPolicy(paylaod) {
    const url = `${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.POST_LIMIT_POLICY}`
    return http.put(url, paylaod).catch(
      (error) => {
        console.error('Error Posting expenses Limit: ', error);
        return Promise.reject(error);
      }
    )
  }

  static fetchExpensePolicyList() {
    const url = `${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.FETCH_EXPENSE_POLICY_LIST}`
    return http.get(url, {params: this.apiConfig.params }).catch(
      (error) => {
        console.error('Error fetching expenses Limit List: ', error);
        return Promise.reject(error);
      }
    )
  }

  static deleteExpensePolicy(payload) {
    const url = `${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.DELETE_EXPENSE_POLICY_LIST}`
    return http.post(url, payload).catch(
      (error) => {
        console.error('Error Posting expenses Limit: ', error);
        return Promise.reject(error);
      }
    )
  }
}

export default ExpenseLimitPolicyService;